import React, { useRef, useState } from "react";
import { FaPlay } from "react-icons/fa";
import { FaPause } from "react-icons/fa6";
import { useInView } from "react-intersection-observer";

const DownloadVideoSection = () => {
  const { ref: tagRef, inView: tagView } = useInView({
    triggerOnce: true,
    threshold: 0.5,
  });
  const { ref: headingRef, inView: headingView } = useInView({
    triggerOnce: true,
    threshold: 0.5,
  });
  return (
    <div className="  flex items-center justify-center flex-col xl:gap-6 lg:gap-5 md:gap-4 gap-3 md:mx-[5%] mx-[2%] z-[5] bg-white ">
      <span
        ref={tagRef}
        className={`${tagView ? `animate-scaleIn anim-preserve` : "opacity-0"
          } text-sm font-inter font-semibold flex justify-start items-center rounded-full  bg-[#EBF7FE] w-max  py-3 px-6`}
      >
        <span
          className={` bg-gradient-to-b from-[#5ECCFF] to-[#407BFF] bg-clip-text text-transparent`}
        >
          How It Works
        </span>
      </span>
      <h1
        ref={headingRef}
        className={`${headingView ? `animate-slideUp anim-preserve z-[3]` : "opacity-0 z-0"
          } xl:text-[3.125rem] lg:text-[2.8rem] md:text-[2.4rem] text-[2.625rem] font-jakarta font-bold md:text-left text-center leading-tight `}
      >
        Already Downloaded?
      </h1>
      <div className=" relative z-[5] bg-white w-full  flex items-center justify-center flex-col xl:gap-6 lg:gap-5 md:gap-4 gap-3">
        <p className="xl:text-[1.438rem] lg:text-[1.2rem] md:text-[1.15rem] text-[1.313rem] font-inter font-medium text-[#636363]">
          Find Out How to Use Zero Typing
        </p>
        <HeroVideo />
      </div>
    </div>
  );
};

const HeroVideo = () => {
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const togglePlay = () => {
    const v = videoRef.current;
    if (!v) return;
    if (v.paused) {
      v.play();
      setIsPlaying(true);
    } else {
      v.pause();
      setIsPlaying(false);
    }
  };

  const { ref: videoAnimationRef, inView: videoAnimationView } = useInView({
    triggerOnce: true,
    threshold: 0.5,
  });

  const THUMB =
    "https://pub-25f4599302a64a3dab9e149b2b5f9a0f.r2.dev/images/HOW%20IT%20WORKS%20THUMBNAIL%201.png";

  return (
    <div
      ref={videoAnimationRef}
      className={`${videoAnimationView
        ? "animate-slideUp anim-preserve z-3"
        : "opacity-0 z-0"
        } relative md:w-[70%] w-[90%] aspect-video bg-black border border-black shadow-2xl shadow-[#c7ced3] flex items-center justify-center rounded-3xl overflow-hidden`}
      onClick={togglePlay}
      role="button"
      aria-label={isPlaying ? "Pause video" : "Play video"}
    >
      {/* Thumbnail overlay with fade + slight zoom */}
      <img
        src={THUMB}
        alt="Video thumbnail"
        className={`absolute inset-0 aspect-video w-full h-full object-cover
          transition-all duration-500 ease-in-out will-change-[opacity,transform]
          ${isPlaying ? "opacity-0 " : "opacity-100 "}`}
        aria-hidden="true"
        draggable={false}
      />

      {/* https://pub-25f4599302a64a3dab9e149b2b5f9a0f.r2.dev/videos/HOW%20IT%20WORKS01.mp4 */}
      {/* Video cross-fades against the thumbnail and eases scale in */}
      <video
        ref={videoRef}
        className={`w-full h-full object-cover 
          transition-all duration-500 ease-in-out will-change-[opacity,transform]
          ${isPlaying ? "opacity-100 " : "opacity-0 "}`}
        src="https://pub-25f4599302a64a3dab9e149b2b5f9a0f.r2.dev/videos/ZT%20Download%20Page%20Video%20.mp4"

        poster={THUMB}
        muted={false}
        playsInline
        preload="metadata"
        loop={false}
        onPlay={() => setIsPlaying(true)}
        onPause={() => setIsPlaying(false)}
        onEnded={() => setIsPlaying(false)}
      />

      {/* Center Play/Pause button (also fades out while playing) */}
      <button
        type="button"
        onClick={(e) => {
          e.stopPropagation();
          togglePlay();
        }}
        className={`absolute inset-0 grid place-items-center transition-opacity duration-300
          ${isPlaying ? "opacity-0 pointer-events-none" : "opacity-100"}`}
        aria-label={isPlaying ? "Pause" : "Play"}
      >
        {isPlaying ? (
          <FaPause className="text-[#3AB1F6] lg:size-24 md:size-12 size-6" />
        ) : (
          <FaPlay className="text-[#3AB1F6] lg:size-24 md:size-12 size-6" />
        )}
      </button>
    </div>
  );
};

export default DownloadVideoSection;
